/*eslint-disable*/export const messages=JSON.parse("{\"pole-position-ad.recommerce.badge\":\"Betalt plassering\"}");